import { get } from '~/shared/http-client/api'
import { type ApiResponse } from '~/shared/http-client/exceptions/type'

// Request Type
export type Section = 'INVITE' | 'VIDEO' | 'BANNER'

export type ImageInfo = {
  id: number
  parent_table_key: number
  original_name: string
  url: string
}

export type EventInfo = {
  id: number
  round: number
  event_type: string
  name: string
  status: string
  place: string
  start_date: string
  end_date: string
  show_date: string
  image: number
  image_info: ImageInfo
}

export type BannerInfo = {
  id: number
  title: string
  desc: string
  link: string
  contents: number
  contents_section: string
  contentsObj: null
}

export type VideoInfo = {
  id: number
  title: string
  desc: string
  link: string
  contents: number
  contents_section: string
  contentsObj: {
    id: number
    parent_table_key: number
    original_name: string
    url: string
  }
}

export type InviteInfo = {
  id: number
  title: string
  desc: string
  link: string
  contents: number
  contents_section: string
  contentsObj: null
}

export type ScheduleInfo = {
  id: number
  event_name: string
  event_date: string
  event_location: string
  event_desc: string
  sort: number
  created_at: string
  updated_at: string
  deleted_at: string
  delete_yn: string
  image_info: {
    id: number
    parent_table_key: number
    original_name: string
    url: string
  }
}

// Response Type
export interface OngoingEventResponse extends ApiResponse {
  data: {
    eventInfo: EventInfo
  }
}

export interface EventScheduleResponse extends ApiResponse {
  data: {
    scheduleList: ScheduleInfo[]
  }
}

export interface MainContentsResponse extends ApiResponse {
  data: {
    ongoing_event: EventInfo
    contents_dic: {
      BANNER: BannerInfo
      VIDEO: VideoInfo
      INVITE: InviteInfo
    }
  }
}

// function

export const getOngoingEvent = () =>
  get<OngoingEventResponse>('/main/ongoingEvent')

export const getEventSchedule = () =>
  get<EventScheduleResponse>('/main/schedule')

export const getMainContents = async () => {
  const response: MainContentsResponse = await get('/main')

  return response.data
}
